// import React from 'react';
// import { Link } from 'react-router-dom';

// // CSS
// import './company-logo.css';

// const CompanyLogo = () => {
//   return (
//     <Link to="/" className="company-logo">
//       <span className="ekhoni">Ekhoni</span>{' '}
//       <span className="khabo">Khabo</span>
//     </Link>
//   );
// };

// export default CompanyLogo;

import React from "react";
import { Link } from "react-router-dom";

// CSS
import "./company-logo.css";

// Import your logo image
// import logo from "../../assets/logo.png"; // Adjust path as needed

const CompanyLogo = () => {
  return (
    <Link to="/" className="company-logo">
      <img
        src="https://ekhonikhabo.com/images/logo.jpeg"
        alt="Company Logo"
        className="logo-image"
      />
      <span className="logo-text">
        <span className="ekhoni">Ekhoni</span>{" "}
        <span className="khabo">Khabo</span>
      </span>
    </Link>
  );
};

export default CompanyLogo;
